import { makeStyles } from '@material-ui/core';
import { vh, vw } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../mui-theme';

const totalLeft = {
  lineHeight: '3.12vh',
  letterSpacing: '0.07vw',
  fontWeight: 500,
  color: themeColor.subheaderLight,
};

export const styles = makeStyles(() => ({
  outerContainer: {
    height: '100%',
    color: themeColor.subheaderLight,
    fontWeight: 500,
    letterSpacing: vw(0.03),
    fontSize: vh(1.3),
    '@media (width: 1024px) and (height: 768px)': {
      fontSize: vh(1.2),
    },
  },
  container: {
    background: themeColor.white,
    borderLeft: `1px solid ${themeColor.secondaryLight}`,
    borderRight: `1px solid ${themeColor.secondaryLight}`,
    height: '100%',
    backgroundColor: themeColor.lightBackground,
  },
  totalContent: {
    padding: '0 0.732vw 1.17vh 0.732vw',
  },
  totalContentCustomer: {
    paddingTop: '1.3vh',
    paddingRight: '2.9vw',
  },
  totalRow: {
    paddingBottom: 6,
  },
  totalRowItem: {
    width: '50%',
  },
  totalRowLeftItem: {
    paddingRight: '1vw',
  },
  totalLeft: {
    ...totalLeft,
  },
  totalLeftCustomer: {
    ...totalLeft,
    color: themeColor.defaultTextColor,
  },
  totalRight: {
    letterSpacing: vw(0.014),
    fontSize: vh(1.6),
    textAlign: 'right',
    fontWeight: 500,
    color: themeColor.defaultTextColor,
  },
  customerTotalListItem: {
    minWidth: '32px',
  },
  customerSavings: {
    '& div': {
      color: themeColor.secondaryContrast,
    },

    '& svg rect': {
      fill: themeColor.secondaryContrast,
    },
  },
  totalItem: {
    height: '100%',
  },
}));
